export const ADMIN_ALL = 1

export const SALES_DISCOUNT = 301
export const SALES_SALE = 302
export const SALES_SERVICE_CHARGE = 303
export const SALES_VOID_ITEM = 304
export const SALES_VOID_SALES = 305
export const SALES_VIEW_ALL_ORDERS = 309
export const SALES_ISSUE_REFUND = 310
export const SALES_ONLINE_ORDER = 311
export const SALES_TOP_UP_GIFT_CARD = 313
export const SALES_TRANSFER_GIFT_CARD = 314
export const SALES_CLOSE_POS_TERMINAL = 307
export const SALES_OPEN_POS_TERMINAL = 306
export const SALES_SELL_GIFT_CARD = 312
export const SALES_QUICK_OUT_OF_STOCK = 315
export const SALES_RESET_SALES = 316
export const SALES_VOID_PAYMENT = 317

/**POS_ADMIN permission */
export const POS_SETUP_GENERAL = 499
export const POS_SETUP_MANAGE_MENUS = 400
export const POS_SETUP_MANAGE_MENU_VIEWS = 401
export const POS_SETUP_MANAGE_SALES_PROCESSING = 410
export const POS_SETUP_MANAGE_VOID_COMP_REASONS = 420
export const POS_SETUP_MANAGE_TABLE_LAYOUT = 430
export const POS_SETUP_MANAGE_PAYMENT = 440
export const POS_SETUP_MANAGE_PAY_IN_OUT_REASONS = 450

export const POS_SETUP_MENU_VIEWS = 0
export const POS_SETUP_PAYMENT_SETTING = 0
export const POS_SETUP_PAYIN_PAYOUT_REASONS_MANAGEMENT = 0

/**REPORT permission */
export const REPORT_READ_DAILY_SALE = 500
export const REPORT_RUN_CLOSE_OF_DAY = 520
export const REPORT_CLOSURE_HISTORY = 521
export const REPORT_INVENTORY_REPORT = 530
export const REPORT_INVENTORY_REPORT_COGS = 531
export const REPORT_EMPLOYEE_REPORT = 540
export const REPORT_CLOSURE_HISTORY_REPORT = 550
export const REPORT_ACCOUNTING_JOURNAL = 560
export const MODULE_REPORT = [
    REPORT_READ_DAILY_SALE,
    REPORT_RUN_CLOSE_OF_DAY,
    REPORT_CLOSURE_HISTORY,
    REPORT_INVENTORY_REPORT,
    REPORT_INVENTORY_REPORT_COGS,
    REPORT_EMPLOYEE_REPORT,
    REPORT_CLOSURE_HISTORY_REPORT,
    REPORT_ACCOUNTING_JOURNAL,
]

export const ACTION_SALES_VOID = [SALES_VOID_ITEM, SALES_VOID_SALES]
export const MODULE_SALES = [
    SALES_DISCOUNT,
    SALES_SERVICE_CHARGE,
    SALES_VOID_ITEM,
    SALES_VOID_SALES,
    SALES_VIEW_ALL_ORDERS,
    SALES_ISSUE_REFUND,
    SALES_TOP_UP_GIFT_CARD,
    SALES_TRANSFER_GIFT_CARD,
    SALES_SELL_GIFT_CARD,
    SALES_QUICK_OUT_OF_STOCK,
    SALES_SALE,
]

export const USERS_MANAGE_COMPANY_ROLE = 1701
export const USERS_MANAGE_LOCATION_ROLE = 1702
export const USERS_MANAGE_ROLE_PERMISSION = 1720
export const USERS_CHANGE_OTHER_USERS_PASSWORD = 1730
export const USER_ALL = [
    USERS_MANAGE_LOCATION_ROLE,
    USERS_MANAGE_COMPANY_ROLE,
    USERS_CHANGE_OTHER_USERS_PASSWORD,
]
export const USERS_NOTIFICATION_GROUPS = 1740

export const SYSTEMSETTUP_SETUP_COMPANY = 140
export const SYSTEMSETTUP_SETUP_LOCATION = 141
export const SYSTEMSETTUP_COMPANY_BRAND = 142
export const SYSTEMSETTUP_SUBSCRIPTION = 143
export const SYSTEM_SETUP_GENERAL = 100
export const SYSTEM_SETUP_ORDER_CHANNEL = 101
export const SYSTEM_SETUP_ORDER_NUMBER = 102
export const SYSTEM_SETUP_FULTILLMENT_OPTIONS = 103
export const SYSTEM_SETUP_TIME_CLOCK = 120
export const SYSTEM_SETUP_DEVICE_MANAGEMENT = 130

export const SYSTEM_SETUP_SETUP_COMPANY = 140
export const SYSTEM_SETUP_SETUP_LOCATION = 141

export const SYSTEM_SETUP_COMPANY_BRANDS = 142
export const SYSTEM_SETUP_SUBSCRIPTION = 143
export const SYSTEM_SETUP_INTEGRATIONS_PAYMENT = 150
export const SYSTEM_SETUP_LOCATION_BRANDS = 160
export const SYSTEM_SETUP_CLOSEING_PROCEDURE = 170
export const SYSTEM_SETUP_GIFT_CARD = 180

export const ROLE_ALL = [USERS_MANAGE_ROLE_PERMISSION]

export const MANAGE_COMPANY_USER = [USERS_MANAGE_COMPANY_ROLE]
export const MANAGE_LOCATION_USER = [USERS_MANAGE_LOCATION_ROLE]

/**
 * CASH Management
 */
export const CASH_MANAGEMENT_MAKE_DEPOSITS = 603
export const CASH_MANAGEMENT_MAKE_PAY_INS = 601
export const CASH_MANAGEMENT_MAKE_PAY_OUTS = 602

export const CUSTOMER_MANAGEMENT_MANAGE_CUSTOMER = 1200
export const CUSTOMER_MANAGEMENT_LOYALTY_SETTING_MANAGEMENT = 1210

export const ORDER_EVENT_MANAGE_ORDER_EVENT = 1400
export const VENDOR_MANAGEMENT_MANAGE_VENDOR = 1500
export const DASHBOARD_DASHBOARD_ADMIN = 1601

export const DISCOUNT_DISCOUNT_MANAGEMENT = 210

export const PRODUCT_MANAGEMENT_PRODUCT = 700
export const PRODUCT_MANAGEMENT_MANIPULATE_GIFT_CARD = 710
export const PRODUCT_MANAGEMENT_ISSUE_GIFT_CARD = 720
export const PRODUCT_MANAGEMENT_COMBOS = 730
export const PRODUCT_MANAGEMENT_INGREDIENTS = 740
export const PRODUCT_PERMISSIONS = [
    PRODUCT_MANAGEMENT_PRODUCT,
    PRODUCT_MANAGEMENT_COMBOS,
    PRODUCT_MANAGEMENT_INGREDIENTS,
]
export const INVENTORY_MANAGEMENT_MANAGE_INVENTORY = 800

export const ONLINE_STORE_MANAGEMENT_MANAGE_ONLINE_STORE = 900
export const ONLINE_STORE_MANAGEMENT_MENU_MANAGEMENT = 920
export const ONLINE_STORE_MANAGEMENT_ORDER_CHANNEL_MANAGEMENT = 930

export const PRICE_LIST_MANAGEMENT_MANAGE_PRICE_LIST = 1000

export const FINANCIAL_MANAGEMENT_GENERAL = 1100
export const FINANCIAL_MANAGEMENT_COMPANY_DETAILS = 1110
export const FINANCIAL_MANAGEMENT_TAXES = 1120
export const FINANCIAL_MANAGEMENT_GLCODES_MANAGEMENT = 1130
export const FINANCIAL_MANAGEMENT_PAYMENT_METHOD = 1140
export const FINANCIAL_MANAGEMENT_PAYMENT_ACCOUNT = 1150

export const RECEIPT_AND_REPORT_MANAGEMENT_MANAGE_RECEIPT = 1300
export const REPORT_MANAGEMENT_MANAGE_REPORT = 1320
